import React from 'react';
import PropTypes from 'prop-types';
import Button from '../Button';

const ActionBar = ({ buttons = [], disabled }) => {
  return (
    <div className="action-bar">
      {buttons.map((button, index) => <Button {...button} key={`button_${index}`} style="link" disabled={disabled} />)}
    </div>
  );
}

ActionBar.propTypes = {
  buttons: PropTypes.array,
  disabled: PropTypes.bool
}

export default ActionBar;
